import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, ViewChild} from '@angular/core';
import {FooterComponent} from './footer/footer.component';
import {RewardsComponent} from './rewards/rewards.component';
import {PartnersComponent} from './partners/partners.component';
import {ProductsComponent} from './products/products.component';
import {ArticlesComponent} from './articles/articles.component';
import {AboutCompanyComponent} from './about-company/about-company.component';
import {DOCUMENT} from '@angular/common';

enum ActiveLink {
  AboutWrap,
  PartnersWrap,
  productsWrap,
  ArticlesWrap,
  RewardsWrap,
  FooterWrap
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})

export class AppComponent implements AfterViewInit {
  @ViewChild('header') header: ElementRef;
  @ViewChild('aboutCompanyWrap', {static: true}) aboutCompanyWrap: ElementRef;
  @ViewChild('partnersWrap', {static: true}) partnersWrap: ElementRef;
  @ViewChild('productsWrap', {static: true}) productsWrap: ElementRef;
  @ViewChild('articlesWrap', {static: true}) articlesWrap: ElementRef;
  @ViewChild('rewardsWrap', {static: true}) rewardsWrap: ElementRef;
  @ViewChild('footerWrap', {static: true}) footerWrap: ElementRef;

  @ViewChild(ArticlesComponent) articlesComponent: ArticlesComponent;
  @ViewChild(PartnersComponent) partnersComponent: PartnersComponent;
  @ViewChild(ProductsComponent) productsComponent: ProductsComponent;
  @ViewChild(RewardsComponent) rewardsComponent: RewardsComponent;
  @ViewChild(FooterComponent) footerComponent: FooterComponent;
  @ViewChild(AboutCompanyComponent) aboutCompanyComponent: AboutCompanyComponent;

  menuHeight = 0;

  activeLink = null;

  aboutActive = ActiveLink.AboutWrap;
  rewardsActive = ActiveLink.RewardsWrap;
  articlesActive = ActiveLink.ArticlesWrap;
  productsActive = ActiveLink.productsWrap;
  partnersActive = ActiveLink.PartnersWrap;
  footerActive = ActiveLink.FooterWrap;
  isMenuVisible = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private changeDetection: ChangeDetectorRef
  ) {
  }

  @HostListener('window:resize') onResize(event: Event): void {
    this.menuChange();
  }

  @HostListener('window:scroll') onScroll(event: Event): void {
    this.menuChange();
    this.aboutCompanyComponent.scrollerRollByOffsetPosition().then(() => {});
  }

  @HostListener('window: keydown.escape') onEscape(): void {
    if (this.isMenuVisible) {
      this.isMenuVisible = false;
    }
  }

  menuChange(): void {
    const headerBottom = this.header.nativeElement.getBoundingClientRect().bottom;

    const topDiff = headerBottom >= 0 ? headerBottom : 0;

    this.activeLink = null;

    const elements = [
      this.aboutCompanyWrap,
      this.partnersWrap,
      this.productsWrap,
      this.articlesWrap,
      this.rewardsWrap,
      this.footerWrap,
    ];

    elements.forEach((it, index) => {
      if (this.isActive(it, topDiff) && this.activeLink !== index) {
        this.activeLink = index;
        this.changeDetection.detectChanges();
      }
    });
  }

  isActive(element: ElementRef, topDiff: number): boolean {
    const windowHeight = this.document.documentElement.clientHeight;
    const boundingRect = element.nativeElement.getBoundingClientRect();
    const elementTop = boundingRect.top - topDiff;
    const elementBottom = boundingRect.bottom - topDiff;

    return elementTop <= 15 && elementBottom > 0 || elementTop > 0 && elementTop < windowHeight && (windowHeight - elementBottom) >= 0;
  }

  scrollToElement(event: MouseEvent, element: ElementRef): void {
    event?.preventDefault();
    this.aboutCompanyComponent.scrollerRollByOffsetPosition(0).then(() => {});
    const elementPosition = element.nativeElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition - this.menuHeight;
    window.scrollBy({top: offsetPosition, behavior: 'smooth' });
  }

  goToTop(event: MouseEvent): void {
    event.preventDefault();
    window.scrollTo(0, 0);
  }

  ngAfterViewInit(): void {
    this.menuHeight = this.header.nativeElement.offsetHeight + 30;
  }

  closeMenu(event: MouseEvent, overlay: HTMLDivElement): void {
    if (event.target === overlay || (event.target as HTMLElement).closest('a')) {
      this.isMenuVisible = false;
    }
  }
}
